import { combineReducers } from "redux";
import {
  SEND_OTP_ERROR,
  SEND_OTP_LOADING,
  SEND_OTP_SUCCESS,
  VERIFY_OTP_ERROR,
  VERIFY_OTP_LOADING,
  VERIFY_OTP_SUCCESS,
} from "../actions/constant";

const otpError = (state = false, action) => {
  switch (action.type) {
    case SEND_OTP_ERROR:
      return action.otpError;
    default:
      return state;
  }
};

const otpLoading = (state = false, action) => {
  switch (action.type) {
    case SEND_OTP_LOADING:
      return action.otpLoading;
    default:
      return state;
  }
};

const otpSuccess = (state = false, action) => {
  switch (action.type) {
    case SEND_OTP_SUCCESS:
      return action.otpSuccess;
    default:
      return state;
  }
};

const resultData = (state = [], action) => {
  switch (action.type) {
    case SEND_OTP_SUCCESS:
      return action.resultData;
    case SEND_OTP_ERROR:
      return action.resultData;
    default:
      return state;
  }
};

const verifyOtpError = (state = false, action) => {
  switch (action.type) {
    case VERIFY_OTP_ERROR:
      return action.verifyOtpError;
    default:
      return state;
  }
};

const verifyOtpLoading = (state = false, action) => {
  switch (action.type) {
    case VERIFY_OTP_LOADING:
      return action.verifyOtpLoading;
    default:
      return state;
  }
};

const verifyOtpSuccess = (state = false, action) => {
  switch (action.type) {
    case VERIFY_OTP_SUCCESS:
      return action.verifyOtpSuccess;
    default:
      return state;
  }
};

const resultVerify = (state = [], action) => {
  switch (action.type) {
    case VERIFY_OTP_SUCCESS:
      return action.resultVerify;
    case VERIFY_OTP_ERROR:
      return action.resultVerify;
    default:
      return state;
  }
};

const otpReducer = combineReducers({
  otpError,
  otpLoading,
  otpSuccess,
  resultData,
  verifyOtpError,
  verifyOtpLoading,
  verifyOtpSuccess,
  resultVerify,
});

export default otpReducer;
